import React, { useEffect, useRef } from 'react';

const TViewTicker = () => {
  const containerRef = useRef(null);
  const scriptRef = useRef(null); // Reference for the dynamically loaded script

  useEffect(() => {
    // Create a new script element
    const script = document.createElement('script');
    script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-ticker-tape.js';
    script.async = true;

    script.innerHTML = JSON.stringify({
      symbols: [
        { proName: 'FX_IDC:EURUSD', title: 'EUR to USD' },
        { description: 'GBP to USD', proName: 'FX:GBPUSD' },
        { description: 'AUD to USD', proName: 'FX:AUDUSD' },
        { description: 'NZD to USD', proName: 'FX:NZDUSD' },
        { description: 'XAU to USD', proName: 'FOREXCOM:XAUUSD' },
        { description: 'USD to JPY', proName: 'FX:USDJPY' },
      ],
      showSymbolLogo: true,
      isTransparent: false,
      largeChartUrl: 'https://tradingview.com/chart/',
      displayMode: 'adaptive',
      colorTheme: 'dark',
      locale: 'en',
    });

    // Append the script to the container
    if (containerRef.current) {
      containerRef.current.appendChild(script);
      scriptRef.current = script; // Save a reference to the script
    }

    return () => {
      // Cleanup: Remove the script if it exists
      if (scriptRef.current && scriptRef.current.parentNode) {
        scriptRef.current.parentNode.removeChild(scriptRef.current);
        scriptRef.current = null; // Clear the reference
      }
    };
  }, []);

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '0px',
        maxWidth: '100%',
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: '1200px',
          height: 'auto',
          overflow: 'hidden',
          boxSizing: 'border-box',
          border: '1px solid #ccc',
          borderRadius: '4px',
        }}
      >
        <div
          className="tradingview-widget-container"
          ref={containerRef}
          style={{
            width: '100%',
            height: 'auto',
          }}
        >
          <div className="tradingview-widget-container__widget"></div>
          <div
            className="tradingview-widget-copyright"
            style={{
              textAlign: 'center',
              marginTop: '5px',
              fontSize: '12px',
            }}
          >
            <a
              href="https://www.tradingview.com/"
              rel="noopener nofollow"
              target="_blank"
              style={{
                textDecoration: 'none',
                color: '#007bff',
              }}
            >
              <span className="blue-text">Track all markets on TradingView</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TViewTicker;
